import styled from "@emotion/styled";
import { noop } from "lodash";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export interface IProps {
  on?: boolean;
  size?: "small" | "normal";
  disabled?: boolean;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?(e: any): void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledSwitchProps {
  on: boolean;
  size?: "small" | "normal";
  disabled?: boolean;
}

const StyledSwitch = styled.div<StyledSwitchProps>`
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => withVar(props.on ? DesignToken.ActionPositiveDefault : DesignToken.ActionNeutralDefault)
  };
  border: none;
  border-radius: 15px;
  box-sizing: border-box;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => !props.disabled && "cursor: pointer"
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.disabled && "opacity: 0.5"
  };

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => {
      switch (props.size) {
        case "small":
          return `
          width: 27px;
          height: 19px;
        `;

        default:
          return `
          width: 43px;
          height: 28px;
        `;
      }
    }
  };
`;

const StyledBubble = styled.div<StyledSwitchProps>`
  position: relative;
  top: 2px;
  border-radius: 50%;
  background-color: ${withVar(DesignToken.ContentLockedWhite)};
  transition:
    left 0.2s ease-in-out,
    background-color 0.2s ease-in-out;
  will-change: left, background-color;

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => {
      switch (props.size) {
        case "small":
          return `
          left: ${props.on ? "10px" : "2px"};
          width: 15px;
          height: 15px;
        `;

        default:
          return `
          left: ${props.on ? "18px" : "2px"};
          width: 23px;
          height: 23px;
        `;
      }
    }
  };
`;

export const Switch: React.FC<IProps> = ({ on = undefined, size = "normal", disabled, onClick }) => (
  // @ts-expect-error TS(2322)
  <StyledSwitch size={size} on={on} disabled={disabled} onClick={disabled ? noop : onClick}>
    {/* @ts-expect-error TS(2322) */}
    <StyledBubble size={size} on={on} />
  </StyledSwitch>
);
